import { Injectable } from "@angular/core";
import { UtilService } from "app/bundles/requests/shared/services/util.service";
import { environment } from "environments/environment";
import * as _ from "lodash-es";
import {
  IWorkorderOrServiceRequestSummary,
  IWorkorderOrServiceRequestDetail,
  RequestSourceTypeEnum,
  IBaseRequestDetail,
  IBaseRequestSummary,
  IWorkorderRequestSummary,
} from "../models/request";
import { IBatchMode, RequestInBatchService } from "./request-in-batch.service";

@Injectable()
export class IconService {
  private batchMode: IBatchMode;

  constructor(
    private utilService: UtilService,
    private requestInBatchService: RequestInBatchService,
  ) {
    this.requestInBatchService.batchMode$.subscribe(
      (batchMode) => (this.batchMode = batchMode),
    );
  }

  getImageName(request: IWorkorderOrServiceRequestSummary): string {
    let icon: any;
    if (this.areIconsAvailable) {
      request.source === RequestSourceTypeEnum.serviceRequest
        ? (icon = environment.iconsConfigSR.icon)
        : (icon = _.find(environment.iconsConfig.icons, (o) => {
            return o.code == request.service.code;
          }));
    }
    icon = icon != null ? icon : environment.iconsConfig.notFound;
    if (request.isSelected && this.batchMode && this.batchMode.isActive) {
      return icon.fileNameSelected;
    }
    if (
      this.utilService.getDelay(request.estimatedCompletionDate) > 0 ||
      request.status.code == "E" ||
      request.isReactivated
    ) {
      return icon.fileNameStatus;
    } else {
      return icon.fileName;
    }
  }

  getIconName(serviceCode: string): string {
    let icon: any;
    if (this.areIconsAvailable) {
      icon = _.find(environment.iconsConfig.icons, (o) => {
        return o.code == serviceCode;
      });
    }
    icon = icon != null ? icon : environment.iconsConfig.notFound;
    return `${environment.iconsConfig.iconsPath}${icon.fileNameStd}`;
  }

  private areIconsAvailable() {
    return (
      environment.iconsConfig &&
      environment.iconsConfig.icons &&
      environment.iconsConfig.icons.length > 0
    );
  }
}
